import { setModalState } from '@actions/quizTaking';
import Button from '@base/Button/Button';
import { ATTEMPT_SUMMARY_TYPE, MODAL_TYPES } from '@cont/Quiz/constants';
import useOngoingSection from '@cont/Quiz/Taking/Common/useOngoingSection';
import styled from '@emotion/styled';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getCurrentQuestionInfo, getQuizDetails } from '@selectors/quizTaking';
import { useToggleable } from '@stores/toggleables';
import { Spacings } from '@styles/index';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import AttemptStates from './AttemptStates';
import Questions from './Questions';

const NavigationWrapper = styled.div`
  background-color: var(--color-base-1);
  height: calc(100vh - 72px);
  position: relative;
`;

const QuestionList = styled.div`
  margin-top: ${Spacings.SPACING_40B};
  overflow: scroll;
  overflow-x: hidden;
  height: ${({ $hasOngoingSectional }) =>
    $hasOngoingSectional ? 'calc(100vh - 305px)' : 'calc(100vh - 233px)'};

  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;

const SubmitButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  height: 81px;
  border-top: 1px solid var(--color-divider);
  width: 272px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-base-1);
  margin-top: ${Spacings.SPACING_2B};
`;

const SubmitSectionButton = styled(Button)`
  width: 224px;
`;

const Navigation = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const { sectionUID } = useSelectorWithShallowEqual(getCurrentQuestionInfo);
  const { hasOngoingSectional } = useOngoingSection(sectionUID);
  const { openElement: openSummaryModal } = useToggleable(
    MODAL_TYPES.ATTEMPT_SUMMARY
  );
  const dispatch = useDispatch();

  const openSummaryModalForSection = () => {
    openSummaryModal();
    dispatch(
      setModalState({
        type: ATTEMPT_SUMMARY_TYPE.SECTION,
        data: {}
      })
    );
  };

  const renderQuestionList = () => (
    <QuestionList $hasOngoingSectional={hasOngoingSectional}>
      {quizDetails.sections.map((section) => (
        <Questions
          key={section.uid}
          title={section.is_default ? 'Questions' : section.title}
          sectionUID={section.uid}
        />
      ))}
    </QuestionList>
  );
  return (
    <NavigationWrapper>
      <AttemptStates />
      {renderQuestionList()}
      {hasOngoingSectional && (
        <SubmitButtonWrapper>
          <SubmitSectionButton
            variant="filled"
            color="black"
            label="Submit section"
            onClick={openSummaryModalForSection}
          />
        </SubmitButtonWrapper>
      )}
    </NavigationWrapper>
  );
};

export default Navigation;
